import { render } from "./Certificado-V1.vue?vue&type=template&id=705097b2&scoped=true"
import script from "./Certificado-V1.vue?vue&type=script&lang=js"
export * from "./Certificado-V1.vue?vue&type=script&lang=js"

import "./Certificado-V1.vue?vue&type=style&index=0&id=705097b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705097b2"]])

export default __exports__